import React, { useEffect, useState } from 'react'
import { FaTimesCircle } from 'react-icons/fa'
import { useStateContext } from '../../../state/context'
import { useSelector, useDispatch } from 'react-redux'
import {toast} from 'react-toastify'
import { addAPatientInvestigationRecord } from '../../../state/actions/nurse.actions'

const NurseAddInvestigationRecordModal = () => {
    const { modals, setModals } = useStateContext()
    const dispatch = useDispatch()

    const { set_patient_id } = useSelector((state) => state.root)
    const handleChange = (e, name) => {
        setFormData((prevState) => ({ ...prevState, [name]: e.target.value }))

    }

    const [formData, setFormData] = useState({
        date: '',
        description: '',
        id: '',

    })

    const handleSubmit = (e) => {
        e.preventDefault()
        // console.log(formData);
        dispatch(addAPatientInvestigationRecord({ formData, toast, setModals, modals }))

    }

    useEffect(() => {
        setFormData({ ...formData, id: set_patient_id?.id })
    }, [])
    return (
        <div>
            <div className='absolute grid h-screen w-full z-20 bg-[#11111180] place-items-center'>
                <div className='bg-white rounded px-[30px] py-[20px] w-[600px]'>
                    <div className='flex flex-col space-y-5'>
                        <div className='flex justify-between items-center'>

                            <>
                                <h4 className='text-dark-green text-[20px] font-bold'>
                                    Add Special Investigation Record
                                </h4>
                                <FaTimesCircle
                                    className='text-dark-yellow cursor-pointer'
                                    onClick={() => (
                                        setModals({
                                            ...modals,
                                            showAddPatientInvestigationRecordModal:
                                                !modals.showAddPatientInvestigationRecordModal,
                                        })
                                    )

                                    }
                                    size={20}
                                />
                            </>


                        </div>




                        <form onSubmit={handleSubmit}>


                            <div className='flex justify-between-items-center space-x-10'>
                                <div className='space-y-2 w-full'>
                                    <p className='text-sm font-semibold'>Investigation</p>
                                    <input
                                        type="title"
                                        name="description"


                                        className="border rounded w-full h-[100px] px-4 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-blue-500 focus:ring-blue 5ounded"
                                        onChange={(e) => handleChange(e, e.target.name)}
                                    />




                                </div>


                            </div>

                            <div className='mt-4 flex justify-center items-center'>
                                <button
                                    type='submit'
                                    className='inline-block w-[175px] px-6 py-2.5 bg-dark-green text-white font-medium text-xs leading-tight rounded shadow-md hover:scale-90 transition duration-500 ease'

                                >
                                    Add
                                </button>
                            </div>

                        </form>

                    </div>
                </div>

            </div>
        </div>
    )
}

export default NurseAddInvestigationRecordModal